<div [formGroup]="form" class="autocomplete-input">
  <mat-form-field class="example-full-width" floatLabel="always">
    <mat-label>{{label}}</mat-label>

    <div class="d-flex justify-content-space-between align-items-center">
      <input
        matInput
        type="text"
        [formControlName]="name"
        [required]="required"
        [readonly]="readonly"
        [placeholder]="placeholder"
        (keyup)="filterOptions($event)">

      @if (!filterValue && options && options.length) {
        <div
          class="arrow-trigger"
          [ngClass]="{'arrow-trigger--rotated': isOptionsOpened}"
          (click)="toggleOptionsDropdown()"
          >
          <div class="arrow-wrapper">
            <div class="select-arrow"></div>
          </div>
        </div>
      }
    </div>

    <mat-error>
      @if (errors[name]) {
        <span>
          {{ errors[name]}}
        </span>
      }
    </mat-error>
  </mat-form-field>

  @if (isOptionsOpened) {
    <div class="select-options">
      @for (option of filteredOptions; track option; let i = $index) {
        <mat-option
          [value]="option"
          (click)="selectOption(option)"
          >
          {{option}}
        </mat-option>
      }
    </div>
  }
</div>
